import { render, staticRenderFns } from "./VehicleOverviewTab.vue?vue&type=template&id=02c4aee4&"
import script from "./VehicleOverviewTab.vue?vue&type=script&lang=js&"
export * from "./VehicleOverviewTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports